import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-changeplan-prepaid',
  templateUrl: './changeplan-prepaid.component.html',
  styleUrls: ['./changeplan-prepaid.component.sass']
})
export class ChangeplanPrepaidComponent implements OnInit {
  @Input() index;
  @Input() soc_des;
  @Input() act_date;
  @Input() actualPrice;
  @Input() plan;
  constructor() { }
  ngOnInit() {
  }
}